module.exports = __webpack_public_path__ + "img/70200.76baee30.jpg";